import React from 'react'
import { useOnboarding } from '../context'

export const useTrackStep = ({ key, step, shouldTrack = true }) => {
  const { trackStep } = useOnboarding()

  React.useEffect(() => {
    if (!shouldTrack || !key) return

    trackStep(key, step)
  }, [shouldTrack, key])
}
